import { ACTION_TYPE } from "reducers/actionType";
import { asListReducer, createFetchingReducer } from "./higherOrderReducers";

// General
export const inputReducer = createFetchingReducer(ACTION_TYPE.INPUT, {
  input: null,
});

export const emailReducer = (state = { email: null }, action) => {
  switch (action.type) {
    case ACTION_TYPE.email:
      return Object.assign({}, state, action.data);
    default:
      return state;
  }
};

export const interestsReducer = asListReducer(
  ACTION_TYPE.INTEREST,
  "userInterests"
);
export const skillsReducer = asListReducer(ACTION_TYPE.SKILL, "userSkills");
export const careersReducer = asListReducer(ACTION_TYPE.CAREER, "userCareers");
export const personalityReducer = asListReducer(
  ACTION_TYPE.PERSONALITY,
  "userPersonality"
);
export const coursesReducer = asListReducer(ACTION_TYPE.COURSE, "userCourses");
export const studysReducer = asListReducer(ACTION_TYPE.STUDY, "userStudys");

export const pickRecSubReducer = (state = { userRecSubs: [] }, action) => {
  switch (action.type) {
    case ACTION_TYPE.pickRecSubs:
      return Object.assign({}, state, action.data);
    default:
      return state;
  }
};
export const pickOthSubReducer = (state = { userOthSubs: [] }, action) => {
  switch (action.type) {
    case ACTION_TYPE.pickOthSubs:
      return Object.assign({}, state, action.data);
    default:
      return state;
  }
};
export const pickAddSubReducer = (state = { userAddSubs: [] }, action) => {
  switch (action.type) {
    case ACTION_TYPE.pickAddSubs:
      return Object.assign({}, state, action.data);
    default:
      return state;
  }
};

export const recommendedSubjectsReducer = (
  state = { recommendedSubjects: [] },
  action
) => {
  switch (action.type) {
    case ACTION_TYPE.recommendedSubjects:
      return Object.assign({}, state, action.data);
    default:
      return state;
  }
};

export const otherSubjectsReducer = (state = { otherSubjects: [] }, action) => {
  switch (action.type) {
    case ACTION_TYPE.otherSubjects:
      return Object.assign({}, state, action.data);
    default:
      return state;
  }
};

export const additionalSubjectsReducer = (
  state = { additionalSubjects: [] },
  action
) => {
  switch (action.type) {
    case ACTION_TYPE.additionalSubjects:
      return Object.assign({}, state, action.data);
    default:
      return state;
  }
};

// User Atar

export const eligibilityReducer = (
  state = { eligibility: null, loading: false, error: null },
  action
) => {
  switch (action.type) {
    case ACTION_TYPE.eligibilityFetch.begin:
    case ACTION_TYPE.eligibilityFetch.success:
    case ACTION_TYPE.eligibilityFetch.failure:
      return Object.assign({}, state, action.data);
    default:
      return state;
  }
};

// Subjects Related
export const recommendationsReducer = (
  state = { recommendations: [], loading: false, error: null },
  action
) => {
  switch (action.type) {
    case ACTION_TYPE.recommendationsFetch.begin:
    case ACTION_TYPE.recommendationsFetch.success:
    case ACTION_TYPE.recommendationsFetch.failure:
      return Object.assign({}, state, action.data);
    default:
      return state;
  }
};

export const saveDraftReducer = (
  state = { loading: false, error: null },
  action
) => {
  switch (action.type) {
    case ACTION_TYPE.saveDraft.begin:
      return Object.assign({}, state, action.data);
    case ACTION_TYPE.saveDraft.success:
      return Object.assign({}, state, action.data);
    case ACTION_TYPE.saveDraft.failure:
      return Object.assign({}, state, action.data);
    default:
      return state;
  }
};
export const emailSummaryReducer = (
  state = {
    loading: false,
    error: null,
  },
  action
) => {
  switch (action.type) {
    case ACTION_TYPE.emailSummary.begin:
    case ACTION_TYPE.emailSummary.success:
    case ACTION_TYPE.emailSummary.failure:
      return Object.assign({}, state, action.data);
    default:
      return state;
  }
};

export const hashReducer = (
  state = { recommendations_input_hash: "", eligibility_input_hash: "" },
  action
) => {
  switch (action.type) {
    case ACTION_TYPE.hash:
      return Object.assign({}, state, action.data);
    default:
      return state;
  }
};
